import Vue from 'vue'

Vue.directive('background-color', function(el, binding) {
  if (binding.value) {
    el.style.backgroundColor = binding.value
  }
})

Vue.directive('background-image', function(el, binding) {
  if (binding && binding.value) {
    el.style.backgroundImage = `url('${binding.value.imageUrl}')`
    el.style.backgroundSize = 'cover'
    el.style.backgroundPosition = 'center'
  }
})

Vue.directive('border-color', function(el, binding) {
  if (binding.value) {
    el.style.borderColor = binding.value
  }
})

Vue.directive('color', function(el, binding) {
  if (binding.value) {
    el.style.color = binding.value
    el.style.textDecorationColor = binding.value
  }
})

Vue.directive('font-style', function(el, binding) {
  if (binding.value) {
    el.style.fontFamily = `${binding.value.fontFamily}, Times-New-Roman`
    el.style.fontWeight = binding.value.fontWeight
    if (binding.value.uppercase) el.style.textTransform = 'uppercase'
    if (binding.value.modifyLeading)
      el.style.marginTop = `${-binding.value.modifyLeading}px`
  }
})
